import type { ComponentType, ReactElement } from 'react';

import type { ContextMenuContainerProps } from '../../components/context_menu/types';
import HelpButton from '../../components/help_button/help_button';
import SelectableItems from '../../components/selectable_items/selectable_items';
import type { ObjectWithId } from '../../types/common';
import FilesGrid from './files_grid';
import type { FilesGridColumn } from './types';

import styles from './asset_files.module.css';

type Props<T extends ObjectWithId> = {
  items: T[];
  contextMenu: ComponentType<ContextMenuContainerProps<T>>;
  columns: FilesGridColumn<T>[];
  uiKey: string;
  title: string;
  help: string;
  selectedIds: string[];
  onSelectIds: (ids: string[]) => void;
};

function TableGroup<T extends ObjectWithId>(props: Props<T>): ReactElement {
  const {
    items,
    contextMenu,
    columns,
    title,
    help,
    uiKey,
    selectedIds,
    onSelectIds,
  } = props;
  const ContextMenu = contextMenu;

  return (
    <div className={styles.table_group}>
      <h3 className={styles.title}>
        {title}
        <HelpButton className={styles.help} path={help} title={title} />
      </h3>
      <SelectableItems
        className={styles.selectable}
        onSelectIds={onSelectIds}
        selectedIds={selectedIds}
        contextMenu={ContextMenu}
        items={items}
        multiselect={false}
      >
        <FilesGrid
          uiKey={uiKey}
          items={items}
          columns={columns}
          selectedIds={selectedIds}
        />
      </SelectableItems>
    </div>
  );
}

export default TableGroup;
